import { Dropdown, Menu } from 'antd';
import { SubstituteMedicineObject } from './ReplaceHEMedicinesModal';

const ReplaceMedicine: React.FC<{
    drugSubstitutesResponse: SubstituteMedicineObject;
    isLast?: boolean;
    index: number;
    onSelectChangeHandler: (medIndex: number, optionIndex: number) => void;
    onToggle: (index: number) => void;
}> = ({ drugSubstitutesResponse, isLast, onToggle, index, onSelectChangeHandler }) => {
    const { medicine, substitutes, selectedIndex, isReplaceable } = drugSubstitutesResponse;
    const drugSubstitutes = substitutes;
    const selectedDrug = drugSubstitutes[selectedIndex];

    const menu = (
        <Menu className="max-h-212 overflow-scroll w-323">
            {drugSubstitutes.map((med, optionIndex) => (
                <Menu.Item onClick={() => onSelectChangeHandler(index, optionIndex)}>
                    <div
                        className="flex-1 space-y-4 px-1 py-4 w-299"
                        style={{ whiteSpace: 'initial' }}
                    >
                        <div className="flex items-start space-x-8 w-full">
                            <p className="font-600">{med.name}</p>
                            {(medicine.form || med.drug_form) && (
                                <p className="h-max text-darwin-neutral-700 bg-white px-4 py-2 mt-3 rounded-4 border border-darwin-neutral-200 text-10">
                                    {medicine.form || med.drug_form}
                                </p>
                            )}
                        </div>
                        <p className="text-darwin-neutral-600 text-11 uppercase w-full leading-5">
                            {med.generic_name || medicine.generic_name}
                        </p>
                        {med.manufacturer_name && (
                            <p className="text-darwin-neutral-700 text-12 w-full leading-5">
                                Manufactured by {med.manufacturer_name}
                            </p>
                        )}
                    </div>
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <div
            className={`grid grid-cols-2 gap-20 px-8 py-16 border-darwin-neutral-100 ${
                !isLast ? 'border-b' : ''
            }`}
        >
            <div className="flex items-center space-x-8">
                <div className="flex-1 space-y-6">
                    <div className="flex items-center space-x-8">
                        <p>{medicine.name}</p>
                        {medicine.form?.trim() && (
                            <p className="whitespace-nowrap text-darwin-neutral-700 px-4 py-2 rounded-4 border border-darwin-neutral-200 text-12 bg-white">
                                {medicine.form}
                            </p>
                        )}
                    </div>
                    <p className="text-13 text-darwin-neutral-700">{medicine.generic_name}</p>
                </div>
                <div>
                    <svg
                        className="w-15 h-14 cursor-pointer fill-darwin-accent-bright-blue-800"
                        viewBox="0 0 15 14"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M14.0209 6.3125C14.4271 6.6875 14.4271 7.34375 14.0209 7.71875L9.02087 12.7188C8.73962 13 8.30212 13.0938 7.92712 12.9375C7.55212 12.7812 7.30212 12.4062 7.30212 12V9H1.58337C0.864624 9 0.333374 8.46875 0.333374 7.75V6.25C0.333374 5.5625 0.864624 5 1.58337 5H7.33337V2C7.33337 1.625 7.55212 1.25 7.92712 1.09375C8.30212 0.9375 8.73962 1.03125 9.02087 1.3125L14.0209 6.3125Z" />
                    </svg>
                </div>
            </div>

            <div className="flex items-center flex-wrap gap-16">
                <Dropdown
                    trigger={['click']}
                    overlay={menu}
                    placement="bottomCenter"
                    className={`rounded-4 ${
                        isReplaceable
                            ? 'border-darwin-primary-500 bg-darwin-primary-100 cursor-pointer'
                            : 'border-darwin-neutral-200 opacity-50 cursor-not-allowed'
                    }`}
                    disabled={!isReplaceable}
                >
                    <div className="flex-1 border px-12 py-10 flex items-center space-x-16">
                        <div className="flex-1 space-y-5">
                            <div className="flex items-start gap-8">
                                <p className="font-600">{selectedDrug.name}</p>
                                {(medicine.form || selectedDrug.drug_form) && (
                                    <p className="text-darwin-neutral-700 bg-white px-4 py-2 rounded-4 border border-darwin-neutral-200 text-10 mt-2">
                                        {medicine.form || selectedDrug?.drug_form}
                                    </p>
                                )}
                            </div>
                            <p className="text-11 uppercase text-darwin-neutral-600">
                                {selectedDrug.generic_name || medicine.generic_name}
                            </p>
                            {selectedDrug.manufacturer_name && (
                                <p className="text-darwin-neutral-700 text-12 w-full leading-5">
                                    Manufactured by {selectedDrug.manufacturer_name}
                                </p>
                            )}
                        </div>

                        <div>
                            <svg
                                className="w-14 h-8 fill-darwin-neutral-900"
                                viewBox="0 0 14 8"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M6.37109 6.87891C6.69922 7.23438 7.27344 7.23438 7.60156 6.87891L12.8516 1.62891C13.207 1.30078 13.207 0.726562 12.8516 0.398438C12.5234 0.0429688 11.9492 0.0429688 11.6211 0.398438L7 5.01953L2.35156 0.398438C2.02344 0.0429688 1.44922 0.0429688 1.12109 0.398438C0.765625 0.726562 0.765625 1.30078 1.12109 1.62891L6.37109 6.87891Z" />
                            </svg>
                        </div>
                    </div>
                </Dropdown>

                <p
                    className="text-darwin-primary-500 font-700 cursor-pointer w-max mr-12"
                    onClick={() => onToggle(index)}
                >
                    {isReplaceable ? (
                        <svg
                            className="w-13 h-13 fill-darwin-status-warning-500"
                            viewBox="0 0 9 10"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M8.60156 1.87891C8.95703 1.55078 8.95703 0.976562 8.60156 0.648438C8.27344 0.292969 7.69922 0.292969 7.37109 0.648438L4.5 3.51953L1.60156 0.648438C1.27344 0.292969 0.699219 0.292969 0.371094 0.648438C0.015625 0.976562 0.015625 1.55078 0.371094 1.87891L3.24219 4.75L0.371094 7.64844C0.015625 7.97656 0.015625 8.55078 0.371094 8.87891C0.699219 9.23438 1.27344 9.23438 1.60156 8.87891L4.5 6.00781L7.37109 8.87891C7.69922 9.23438 8.27344 9.23438 8.60156 8.87891C8.95703 8.55078 8.95703 7.97656 8.60156 7.64844L5.73047 4.75L8.60156 1.87891Z" />
                        </svg>
                    ) : (
                        <svg
                            className="w-13 h-13 fill-darwin-accent-sulphur-green-500"
                            viewBox="0 0 13 12"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M7.375 0.9375C7.375 0.472656 6.96484 0.0625 6.5 0.0625C6.00781 0.0625 5.625 0.472656 5.625 0.9375V4.875H1.6875C1.19531 4.875 0.8125 5.28516 0.8125 5.75C0.8125 6.24219 1.19531 6.625 1.6875 6.625H5.625V10.5625C5.625 11.0547 6.00781 11.4375 6.5 11.4375C6.96484 11.4375 7.375 11.0547 7.375 10.5625V6.625H11.3125C11.7773 6.625 12.1875 6.24219 12.1875 5.75C12.1875 5.28516 11.7773 4.875 11.3125 4.875H7.375V0.9375Z" />
                        </svg>
                    )}
                </p>
            </div>
        </div>
    );
};

export default ReplaceMedicine;
